export default "__VITE_ASSET__BdlX_Ac3__"